
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(102|13|294)|5(363|513|712)|1598|2646|3931|7323|7591|8279|968|9972)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
